// src/pages/Enseignants/PrepaPhysique/PrepaPhysiqueCoaching.jsx
import React, { useState } from "react";
import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";
import useScrollToTop from "../../../hooks/useScollToTop";
import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import HeaderTitle from "../../../components/HeaderTitle/HeaderTitle";
import Button from "../../../components/Button/Button";
import ExerciseListSection from "./ExerciseListSection"; // à créer
import ExerciseAssignmentSection from "./ExerciseAssignmentSection"; // à créer
import { ToastContainer } from "react-toastify";
import { FaListUl, FaUserFriends } from "react-icons/fa";

const PrepaPhysiqueCoaching = () => {
  useScrollToTop();
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);
  const [activeTab, setActiveTab] = useState("exercices"); // "exercices" | "assignations"

  return (
    <section className="w-full">
      {/* Offset navbar */}
      <div className="pt-[150px]" aria-hidden />

      <div className="mx-auto w-full max-w-7xl px-3 sm:px-6">
        {/* Titre page */}
        <HeaderTitle
          role="Enseignant"
          title="Préparation Physique des Compétiteurs"
          align="center"
          className="mb-1"
        />

        {/* Navigation secondaire */}
        <div className="mt-3 mb-6">
          <DashboardNavigation role={userRole} />
        </div>

        {/* Carte principale */}
        <div className="rounded-2xl overflow-hidden shadow ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white/80 dark:bg-slate-900/60 backdrop-blur mb-4">
          {/* Bandeau dégradé + onglets */}
          <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500">
            <div className="px-5 py-6 sm:px-8 text-white">
              <h2 className="text-lg sm:text-xl font-semibold text-center">
                Outils d’entraînement – Force, cardio, mobilité & prévention
              </h2>
              <p className="text-sm/6 opacity-95 max-w-3xl mx-auto text-center mt-1">
                Centralisez vos exercices et assignez des protocoles ciblés aux
                compétiteurs.
              </p>

              {/* Onglets */}
              <div className="mt-5 flex items-center justify-center">
                <div className="inline-flex rounded-2xl ring-1 ring-white/40 bg-white/10 backdrop-blur p-1 gap-4 sm:gap-6">
                  <Button
                    text="Gestion des exercices"
                    icon={FaListUl}
                    onClick={() => setActiveTab("exercices")}
                    className={`!bg-white !text-slate-900 !hover:bg-white/90 !rounded-xl !shadow-md gap-1 self-start sm:self-auto
    ${
      activeTab === "exercices"
        ? "!ring-2 !ring-violet-300 font-semibold gap-2"
        : ""
    }`}
                  />

                  <Button
                    text="Affectations adhérents"
                    icon={FaUserFriends}
                    onClick={() => setActiveTab("assignations")}
                    className={`!bg-white !text-slate-900 !hover:bg-white/90 !rounded-xl !shadow-md gap-1 self-start sm:self-auto
    ${
      activeTab === "assignations"
        ? "!ring-2 !ring-violet-300 font-semibold gap-2"
        : ""
    }`}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Contenu */}
          <div className="px-5 py-6 sm:px-8">
            {activeTab === "exercices" ? (
              <ExerciseListSection />
            ) : (
              <ExerciseAssignmentSection />
            )}
          </div>
        </div>
      </div>

      <ToastContainer />
    </section>
  );
};

export default PrepaPhysiqueCoaching;
